import React, {useContext} from 'react';
import FormField, {Props} from '@src/components/Form/FormField';
import {ITechOperationModel} from '@src/@interfaces/models/TechOperation/ITechOperationModel';
import {FormDataProviderAPIContext} from '@src/contexts/FormDataProviderAPIContext';
import TechOperationSelect from '@views/tech-operations/fields/TechOperationSelect';

function ActualForm(props: Props<ITechOperationModel>) {
    const {modelOptions = {}} = useContext(FormDataProviderAPIContext) ?? {};

    return <TechOperationSelect {...props} options={modelOptions.materialCategories}/>;
}

export default function TechOperationMaterialCategoriesField(props: { name: string }) {
    return <FormField<ITechOperationModel>
            id={props.name}
            formName="base-option-edit-form"
            fieldLabel="TechOperationsShow.fields.material-categories"
            type="nested_list"
            fieldName={props.name}
            config={{
                label: 'TechOperationsShow.fields.material-categories'
            }}
            fieldElement={ActualForm as any}
    />;
}
